import type { QueryKey, UseQueryResult, UseQueryOptions, QueryOptions } from "@tanstack/react-query";
import { useQuery } from "@tanstack/react-query";
import client from "@/api/client/axios";
import type { GetElevatorsQueryResponse, GetElevatorsQueryParams, GetElevators403, GetElevators500 } from "../types/GetElevators";

export const getElevatorsQueryKey = (params?: GetElevatorsQueryParams) =>     [{url:`/api/elevators`},...(params ? [params] : [])] as const;
      export function getElevatorsQueryOptions <TData = GetElevatorsQueryResponse, TError = GetElevators403 | GetElevators500>(params?: GetElevatorsQueryParams, options: Partial<Parameters<typeof client>[0]> = {}): UseQueryOptions<TData, TError> {
        const queryKey = getElevatorsQueryKey(params);

        return {
          queryKey,
          queryFn: () => {
            
            return client<TData, TError>({
              method: "get",
              url: `/api/elevators`,
              params,
              
              ...options,
            }).then(res => res.data);
          },
        };
      };
      
/**
 * @summary Запрос на получение элеваторов
 * @link /api/elevators
 */

export function useGetElevators <TData = GetElevatorsQueryResponse, TError = GetElevators403 | GetElevators500>(params?: GetElevatorsQueryParams, options: {
          query?: UseQueryOptions<TData, TError>,
          client?: Partial<Parameters<typeof client<TData, TError>>[0]>,
        } = {}): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const { query: queryOptions, client: clientOptions = {} } = options ?? {};
  const queryKey = queryOptions?.queryKey ?? getElevatorsQueryKey(params);

  const query = useQuery<TData, TError>({
    ...getElevatorsQueryOptions<TData, TError>(params, clientOptions),
    ...queryOptions
  }) as UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryKey as QueryKey;

  return query;
};
